import styles from "./commonFilter.module.css";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useDebounce } from "../../../customHooks/debounce";
import { setFilter } from "../../../features/filter/commonFilterSlice";

export const CommonFilter = ({
  filterBy,
  placeHolder,
  label,
  filterSetter = setFilter,
}) => {
  const dispatch = useDispatch();
  const [valueToDelaySearch, setValueToDelaySearch] = useState({
    property: filterBy,
    value: "",
  });
  const debounceValue = useDebounce(valueToDelaySearch);

  const handleFilter = (e) => {
    setValueToDelaySearch({
      property: e.target.name,
      value: e.target.value,
    });
  };

  useEffect(() => {
    dispatch(filterSetter(debounceValue));
  }, [dispatch, debounceValue, filterSetter]);

  return (
    <div className={styles.filterContainer}>
      <section className={styles.filterSection}>
        <label>{label}</label>
        <input
          type="text"
          id={filterBy}
          name={filterBy}
          placeholder={placeHolder}
          value={valueToDelaySearch.value}
          onChange={(e) => handleFilter(e)}
        />
      </section>
    </div>
  );
};
